import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/32/thumb-landscape.jpg"

const Post32 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">Maison Margiela／グラムスラム／28 x16 x7cm</span>   
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>世界中のファッション好きの男女に愛されているブランドMAISON MARGIELA（メゾン・マルジェラ）。ウェア、アクセサリー、シューズ、フレグランスなど幅広く展開していますが、バッグもとっても魅力的です。今回はマルジェラで人気のバッグをご紹介します。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-two-cloumn">
          <h2>メゾン・マルジェラとは？</h2>          
          <p>フランスを拠点とするファッションブランドで、メゾン マルタン マルジェラ(Maison Martin Margiela)として1989年春夏のパリコレでデビューしました。<br></br>当時、流行していたゆったりしたシルエットに反し、ボディにフィットした細いジャケットやボトムを発表。その後、タイトなシルエットが盛り上がりをみせてきます。トレンドを一変させるようなことから「脱構築(デコンストラクション)」や「デストロイ・コレクション」と称賛されました。<br></br>創業者のマルタン・マルジェラは、1998-1999年秋冬から2004年春夏までエルメスのレディースプレタポルテのデザインも手掛ける実力者で、多くのファッションラバーたちの心を掴んでいきました。<br></br>2014年には、ジョン・ガリアーノがクリエイティブ・ディレクターに就任し、その後ブランド名を「メゾン マルジェラ(Maison Margiela)」に改名しました。</p>
        </div>
        <figure>
            <StaticImage src="../../images/posts/32/1.jpg" alt="" />
            <span className="text-center">Maison Margiela／グラムスラム／28 x16 x7cm</span>   
        </figure>        
        <div className="text-max-width">
          <h2>マルジェラのおすすめバッグ</h2>
          <p>ジョン・ガリアーノの就任後、デザインを手掛けたバッグコレクションに注目が集まっています。中でも人気の2型は、「グラムスラム」と「5AC」。サイズや素材、カラーのバリエーションが豊富です。あなたなら、どれを選びますか？</p>
          <figure>
            <StaticImage src="../../images/posts/32/2.jpg" alt="" />
            <span className="text-center">Maison Margiela／グラムスラム／18 x12 x7cm</span>   
            <span className="text-center">クッションみたいにフカフカなグラムスラム</span>
          </figure>
          <figure>
            <StaticImage src="../../images/posts/32/3.jpg" alt="" />
            <span className="text-center">Maison Margiela／5AC／26 x18 x13cm</span>   
            <span className="text-center">幅広いスタイリングが楽しめる5AC</span>
          </figure>
        </div>        
        <div className="text-max-width">
          <h2>5AC</h2>
          <p>2016年の春夏コレクションに登場して以来、アイコンバッグとして君臨！モードにもコンサバティブにも使える振り幅が魅力です。フランス語で「バッグ」を意味するSACの“S“を“5”に置き換えたいう5ACのネーミングにも、遊び心があふれています。</p>
        <figure>
          <StaticImage src="../../images/posts/32/4.jpg" alt="" />
          <span className="text-center">Maison Margiela／5AC／26 x18 x13cm</span>   
        </figure>
        </div>
        <div className="text-max-width">
          <p>このフォルムなら、セレモニーバッグとしても使えそうです。ハレの日も、日常も、そんな欲張りな願いも叶います！</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/32/5.png" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/32/6.jpg" alt="" />
          </figure>
        </div>       
        <span className="text-center">Maison Margiela／5AC／35 x24 x17cm</span>    
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/32/7.jpg" alt="" />
            <span className="text-center">背面には4ステッチ</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/32/8.jpg" alt="" />
            <span className="text-center">底には形違いのスタッズ</span>
          </figure>          
        </div>
        <Link to="https://laxus.co/app/pc/bags/maisonmargiela" className="view-all-button">
          メゾン・マルジェラのバッグを見る
        </Link>
        <div className="text-max-width">
          <figure className="img-small">
            <StaticImage src="../../images/posts/32/9.png" alt="" />
          </figure>
          <p>こちらは横幅22cmと小さいタイプ。コロンとしたシルエットが可愛らしい印象です。レッドはブラウン、ブラック、ネイビー、グレーなどの定番カラーと好相性。しっくりキマリます！</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/32/10.jpg" alt="" />
          <span className="text-center">Maison Margiela／5AC／22 x15 x10cm</span>    
        </figure>
        <p>ライナーにはマルジェラ代名詞のタグ。表に出すとまた違う雰囲気に変わります。</p>
        <div className="text-max-width">
          <p>シルバーのレザーにペイントしたような質感。これこそマルジェラ！と言いたくなるようなスペシャルな一品です。縦横どちらでもA4書類が入る大きめサイズ。お仕事バッグにいかがでしょうか？</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/32/11.png" alt="" /> 
          </figure>
          <p>シルバーはグレーの一種だと考えるとスタイリングのハードルがぐっと下がります。ベージュとグレーは上品な組み合わせ。そこにベビーピンクのパンツでスパイスを！</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/32/12.jpg" alt="" />
          <span className="text-center">Maison Margiela／5AC／41 x38 x19cm</span>   
        </figure>
        <div className="text-max-width">
          <h2>Glam Slam（グラムスラム）</h2>
          <p>2018年の春夏コレクションで発表されたグラムスラム。柔らかいレザーを使い、ふんわりとした素材感が特徴です。クラッチとしても、取り外し可能なストラップを付けてショルダーバッグとしても使えます。</p>          
          <figure>
            <StaticImage src="../../images/posts/32/13.jpg" alt="" />
            <span className="text-center">Maison Margiela／グラムスラム／16 x13 x5cm</span>   
          </figure>
        </div>
        <div className="text-max-width">
          <p>クラッチバッグをカジュアルにスタイリングしてもマルジェラなら違和感なし！スマホにお財布など、必要最低限のものは入ります。</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/32/14.png" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/32/15.jpg" alt="" />
            <span className="text-center">Maison Margiela／グラムスラム／28 x16 x7cm</span>   
          </figure>        
        </div>
        <div className="text-max-width">
          <p>こちらは横幅45cmと一般的なクッションくらいのサイズ感！存在感抜群です。ガーリーなワンピも途端にモードに変身。</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/32/16.png" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/32/17.jpg" alt="" />
            <span className="text-center">Maison Margiela／グラムスラム／45 x33 x15cm</span>   
          </figure>          
        </div>
        <div className="text-two-cloumn">
          <h2>攻めバッグはラクサスで<br className="pc"></br>選ぶのが正解！</h2>
          <p>ラクサスではLOUIS VUITTONやCHANEL、HERMESといった有名ラグジュアリーブランドのバッグだけでなく、メゾン・マルジェラのようなファッショニスタ御用達ブランドも取り扱っています。<br></br>メゾン・マルジェラは、一癖あるデザインがブランドの持ち味。バッグも例外ではありません。<br></br>「ちょっと、冒険したい！」そんな時こそ、ラクサスを使ってみてください。</p>
        </div>
        <Link to="https://laxus.co/app/pc/bags/maisonmargiela" className="view-all-button">
          メゾン・マルジェラのバッグを見る
        </Link>        
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post32

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 32}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
